import type { ActionButtonType } from "@/components/event-action/event/action-buttons/ActionButton";
import IHOrderModalWrapper from "./IHOrderModalWrapper.vue";

const CreateA3A5Button: ActionButtonType = {
  label: "license.ih.ih.createIHOrder",
  disabled: false,
  modalComponent: IHOrderModalWrapper,
  // Kill it please please
  isIHOrderButton: true,
};
export default CreateA3A5Button;
